import { updateAudioIsPlaying as updateIsPlaying } from './slice';
import { AppThunk } from '../../../app/store';

export const updateAudioIsPlaying =
  (isPlaying: boolean): AppThunk =>
  dispatch => {
    dispatch(updateIsPlaying(isPlaying));
  };
